import React from 'react';
const SignIn = React.lazy(()=>import('./pages/auth/SignIn'));

const route = [
    { path:'/signIn',exact:true, name:'SignIn',component:SignIn }
];

export default route;